// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import BulletedList20 from './BulletedList20';
import BulletedList24 from './BulletedList24';

type BulletedListProps = {
    variation: '20' | '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    BulletedList20,
    BulletedList24,
};

const BulletedList: FC<BulletedListProps> = ({ variation, ...props }) => {
    const variationKey = `BulletedList${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"BulletedList" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default BulletedList;
